/* ============================================================================
   McDuffy Quiz v2 — VIEW (state → DOM)
   ----------------------------------------------------------------------------
   Renders the current screen, owns motion (opacity cross-fade per 01-spec),
   event delegation, focus management, ARIA. No business logic — it calls the
   engine and reports interactions through hooks. Browser global window.MQ_View.

   Motion vocabulary (01-INTERACTIONS): opacity-led, fast, no bounce/slide.
   prefers-reduced-motion honored (instant swaps).
   ============================================================================ */
(function (root) {
  'use strict';
  var DATA = root.MQ_DATA, SCREENS = root.MQ_SCREENS;

  var _rmq = (typeof window !== 'undefined' && window.matchMedia) ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false, addEventListener: function () {} };
  var _reduce = _rmq.matches;
  if (_rmq.addEventListener) _rmq.addEventListener('change', function (e) { _reduce = e.matches; });
  function reducedMotion() { return _reduce; }
  /* REVEAL_MAX_MS: observed live /reveal latency routinely exceeds 3.5s (Railway
     compute + quote math) — at 3500 most customers saw the "finish the numbers on
     the next step" fallback flash UNDER the "portion is ready" headline, then the
     real numbers popped in. 7s keeps the cooking-dog running over normal latency;
     the timeout remains as the stalled-connection escape hatch. */
  var ROUTE_MS = 200, HOLD_MS = 150, REVEAL_MAX_MS = 7000;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function el(html) { var d = document.createElement('div'); d.innerHTML = html.trim(); return d.firstChild; }
  function peso(n) {
    /* centavo-precise to match what the server bills (₱900.50) — see boot.js peso() */
    var v = Math.round((Number(n) || 0) * 100) / 100;
    return '₱' + v.toLocaleString('en-PH', { minimumFractionDigits: (v % 1 ? 2 : 0), maximumFractionDigits: 2 });
  }

  function mountView(rootEl, engine, hooks) {
    hooks = hooks || {};
    var track = hooks.track || function () {};
    var shell = el(
      '<div class="mq-root" role="application" aria-label="McDuffy meal-plan quiz">' +
        '<div class="mq-topbar">' +
          '<span class="mq-wordmark" role="img" aria-label="McDuffy"></span>' +
          '<a class="mq-shop-once" href="/products/mcduffys-gently-home-cooked-complete-dog-food?view=one-time-shop-v8" data-quiz-shop-once>Shop once</a>' +
          /* Persistent "Discount applied" pill removed 2026-07-03 — the discount is
             stated once, strongly, where price lives (reveal tier line, plan
             schedule, review banner); an every-screen pill was redundant. */
        '</div>' +
        '<div class="mq-shell">' +
        '<div class="mq-chrome">' +
          '<button type="button" class="mq-back" data-action="back" aria-label="Go back" hidden>' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
          '<div class="mq-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
            '<div class="mq-progress__fill"></div>' +
            '<span class="mq-progress__mascot" aria-hidden="true">' + dogMascotSVG() + '</span>' +
          '</div>' +
          '<div class="mq-chapters" aria-hidden="true"></div>' +
        '</div>' +
        '<div class="mq-stage"><div class="mq-screen" data-state="active" tabindex="-1"></div></div>' +
        '<span class="mq-shell-dogwrap" aria-hidden="true"><svg class="mq-shell-dog" viewBox="0 0 240 280" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M84 152c-14 18-22 44-22 72 0 14 4 22 14 24 26 6 62 6 88 0 10-2 14-10 14-24 0-28-8-54-22-72"/>' +
          '<path d="M104 202v42m0 0c-7 0-13-2-13-9"/>' +
          '<path d="M136 202v42m0 0c7 0 13-2 13-9"/>' +
          '<path d="M84 152c-12-10-18-28-16-46 3-28 26-48 52-48 26 0 49 20 52 48 2 18-4 36-16 46"/>' +
          '<path d="M72 110c-12 4-22 22-20 40 1 10 12 14 20 8"/>' +
          '<path d="M168 110c12 4 22 22 20 40-1 10-12 14-20 8"/>' +
          '<path d="M104 140c3 10 9 16 16 16 7 0 13-6 16-16"/>' +
          '<path class="mq-dog-tail" d="M186 198c18-4 28-18 24-34-3-10-14-10-20-2"/>' +
          '<ellipse cx="120" cy="140" rx="6" ry="4.5" fill="currentColor" stroke="none"/>' +
          '<circle class="mq-dog-eye" cx="100" cy="106" r="4.5" fill="currentColor" stroke="none"/>' +
          '<circle class="mq-dog-eye" cx="140" cy="106" r="4.5" fill="currentColor" stroke="none"/>' +
        '</svg></span>' +
        '</div>' +
        '<div class="mq-navbar">' +
          '<button type="button" class="mq-nav-back" data-action="back" aria-label="Go back"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="mq-nav-next" data-action="next" disabled>Next <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '</div>' +
        '<div class="mq-live mq-visually-hidden" aria-live="polite"></div>' +
      '</div>'
    );
    rootEl.innerHTML = '';
    rootEl.appendChild(shell);

    var screenEl = shell.querySelector('.mq-screen');
    var backBtn = shell.querySelector('.mq-back');
    var fillEl = shell.querySelector('.mq-progress__fill');
    var mascotEl = shell.querySelector('.mq-progress__mascot');
    var progEl = shell.querySelector('.mq-progress');
    var chaptersEl = shell.querySelector('.mq-chapters');
    var liveEl = shell.querySelector('.mq-live');
    var dogwrapEl = shell.querySelector('.mq-shell-dogwrap');
    var navBackBtn = shell.querySelector('.mq-nav-back');
    var navNextBtn = shell.querySelector('.mq-nav-next');

    /* delegated actions that don't depend on the current screen builder */
    shell.addEventListener('click', function (e) {
      var a = e.target.closest('[data-action]');
      if (!a) return;
      if (a.dataset.action === 'back') { track('quiz_back', { fromScreen: cur().screenId }); engine.back(); }
      if (a.dataset.action === 'next') {
        if (navNextBtn && navNextBtn.disabled) return;
        /* Next mirrors the current screen's own advance control (Confirm / CTA / sticky CTA / Skip)
           — the sticky CTA covers plan→review and review→checkout (handoff) */
        var adv = screenEl.querySelector('.mq-confirm.is-revealed, .mq-cta:not([hidden]):not([disabled]), .mq-sticky__cta');
        if (adv) { adv.click(); return; }
        var sk = screenEl.querySelector('.mq-skip');
        if (sk && !engine.validate().ok) { sk.click(); return; }
        engine.next();
      }
      if (a.dataset.action === 'goto-chapter') {
        /* clickable phase tabs — jump back to any chapter already reached; answers persist */
        var chap = a.getAttribute('data-chapter'); if (!chap) return;
        var f = engine.flow(); var target = -1;
        for (var fi = 0; fi < f.length; fi++) { if (f[fi].chapter === chap) { target = fi; break; } }
        if (target >= 0 && target <= engine.state.maxStepReached) engine.gotoScreen(f[target].screenId, f[target].dogIndex);
      }
    });
    function syncNav() {
      if (!navNextBtn) return;
      var okAdvance; try { okAdvance = engine.validate().ok; } catch (e) { okAdvance = false; }
      var hasSkip = !!screenEl.querySelector('.mq-skip');
      var hasCta = !!screenEl.querySelector('.mq-cta:not([hidden]):not([disabled]), .mq-sticky__cta');
      navNextBtn.disabled = !(okAdvance || hasSkip || hasCta);
    }
    try {
      var _navObs = new MutationObserver(function () { syncNav(); });
      _navObs.observe(screenEl, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'disabled', 'style'] });
    } catch (e) {}
    /* ONE delegated outside-click closer for every typeahead (breed/brand) — replaces the old
       per-instance document listeners that leaked one handler per mount. */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.mq-typeahead')) return;
      [].forEach.call(rootEl.querySelectorAll('.mq-typeahead.is-open'), function (ta) {
        ta.classList.remove('is-open');
        var inp = ta.querySelector('input'); if (inp) inp.setAttribute('aria-expanded', 'false');
      });
    });

    function cur() { return engine.currentStep() || {}; }

    function renderChrome(s) {
      var pct = s.progress;
      fillEl.style.width = pct + '%';
      mascotEl.style.left = pct + '%';
      progEl.setAttribute('aria-valuenow', String(pct));
      progEl.setAttribute('aria-valuetext', (s.chapter ? chapterLabel(s.chapter) + ' — ' : '') + pct + '% complete');
      backBtn.hidden = s.isFirst;
      /* clickable phase tabs — jump back to any chapter already reached (answers persist) */
      var chapters = SCREENS.CHAPTERS;
      var activeIdx = chapters.map(function (c) { return c.id; }).indexOf(s.chapter);
      var f = engine.flow(); var chapFirst = {};
      f.forEach(function (st, i) { if (chapFirst[st.chapter] === undefined) chapFirst[st.chapter] = i; });
      chaptersEl.innerHTML = chapters.map(function (c, i) {
        var clickable = chapFirst[c.id] !== undefined && chapFirst[c.id] <= engine.state.maxStepReached && i !== activeIdx;
        var cls = 'mq-chip' + (i < activeIdx ? ' is-done' : '') + (i === activeIdx ? ' is-active' : '') + (clickable ? ' is-clickable' : '');
        if (clickable) return '<button type="button" class="' + cls + '" data-action="goto-chapter" data-chapter="' + esc(c.id) + '"><span class="mq-chip__label">' + esc(c.label) + '</span></button>';
        return '<span class="' + cls + '"><span class="mq-chip__label">' + esc(c.label) + '</span></span>';
      }).join('');
      /* render the corner dog; the bowl shows the ACTIVE dog's name (multi-dog:
         Luna's questions get Luna's bowl, not dog 0's) and re-renders on change */
      var activeDi = (s.step && s.step.dogIndex != null) ? s.step.dogIndex : 0;
      var dogNm = ((engine.tokens && engine.tokens(activeDi)) || {}).Name || '';
      if (dogwrapEl && (lastDogPose !== 'sit' || lastDogName !== dogNm)) { dogwrapEl.innerHTML = dogPoseSVG(s.chapter, 'mq-shell-dog', dogNm); lastDogPose = 'sit'; lastDogName = dogNm; }
      if (navBackBtn) navBackBtn.disabled = s.isFirst;
      syncNav();
    }
    function chapterLabel(id) { var c = SCREENS.CHAPTERS.filter(function (x) { return x.id === id; })[0]; return c ? c.label : ''; }

    function announce(msg) { liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = msg; }, 30); }

    /* ---- cross-fade route controller (01-spec §2) ---- */
    function swap(renderFn) {
      if (reducedMotion()) { screenEl.dataset.state = 'active'; renderFn(); focusHeading(); return; }
      screenEl.dataset.state = 'leaving';
      var onLeave = function (e) {
        if (e.propertyName !== 'opacity') return;
        screenEl.removeEventListener('transitionend', onLeave);
        renderFn();
        screenEl.dataset.state = 'entering';
        /* force reflow */ void screenEl.offsetHeight;
        screenEl.dataset.state = 'active';
        focusHeading();
      };
      screenEl.addEventListener('transitionend', onLeave);
      /* safety: if no transition fires */
      setTimeout(function () { if (screenEl.dataset.state === 'leaving') { onLeave({ propertyName: 'opacity' }); } }, ROUTE_MS + 120);
    }
    function focusHeading() {
      var h = screenEl.querySelector('[data-focus], h1, h2');
      /* preventScroll so focusing the heading doesn't jump; scroll the WIDGET
         (not window) to the new question's top — never window.scrollTo(0,0). */
      if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      try { screenEl.scrollIntoView({ block: 'start' }); } catch (e) {}
    }

    /* ---- main render ---- */
    var lastScreenKey = null, lastProgress = -1, lastDogPose = null, lastDogName = null;
    function render(opts) {
      var s = engine.getState();
      renderChrome(s);
      if (s.progress !== lastProgress) { if (hooks.onProgress) hooks.onProgress(s.progress); lastProgress = s.progress; }
      var step = s.step, screen = s.screen;
      var key = step.screenId + '#' + step.dogIndex;
      var build = BUILDERS[screen.kind] || BUILDERS._fallback;
      var doRender = function () {
        screenEl.innerHTML = '';
        var node = build(screen, step, s);
        screenEl.appendChild(node);
        if (build.mount) build.mount(node, screen, step, s);
        announce(stripTags(screen ? engine.resolveText(screen.prompt, step.dogIndex) : ''));
        track('quiz_step_view', { screenId: step.screenId, phase: step.chapter, dogIndex: step.dogIndex });
      };
      if (opts && opts.instant) { doRender(); focusHeading(); lastScreenKey = key; }
      else if (key !== lastScreenKey) { swap(doRender); lastScreenKey = key; }
      /* same screen → DON'T rebuild: builders manage their own DOM imperatively
         (rebuilding here would drop input focus/cursor and wipe revealed panels).
         Chrome (progress/back/chapters) was already refreshed above. */
    }
    function stripTags(s) { return String(s || '').replace(/<[^>]+>/g, ''); }

    /* ===================================================================
       SCREEN BUILDERS — each returns a DOM node; optional .mount(node,...)
       wires events. They use the engine for all state changes.
       =================================================================== */
    function header(screen, step, s) {
      var introTxt = screen.intro ? engine.resolveText(screen.intro, step.dogIndex) : '';
      var promptTxt = engine.resolveText(screen.prompt, step.dogIndex);
      var subTxt = screen.sub ? engine.resolveText(screen.sub, step.dogIndex) : '';
      /* underline the last word with a hand-drawn swash (tails signature) */
      var safe = esc(promptTxt);
      var m = safe.match(/^([\s\S]*\s)(\S+)$/);
      var promptHTML = m ? (m[1] + '<span class="mq-underline">' + m[2] + '</span>') : ('<span class="mq-underline">' + safe + '</span>');
      return (introTxt ? '<p class="mq-kicker">' + esc(introTxt) + '</p>' : '') +
        '<h1 class="mq-prompt" data-focus tabindex="-1">' + promptHTML + '</h1>' +
        (subTxt ? '<p class="mq-sub">' + esc(subTxt) + '</p>' : '');
    }
    function infoPanel(screen, step) {
      if (!screen.info) return '';
      var info = screen.info;
      var body = engine.resolveText(info.body, step.dogIndex);
      var heading = info.heading ? '<strong class="mq-panel__heading">' + esc(info.heading) + '</strong>' : '';
      return '<aside class="mq-panel" data-variant="' + (info.variant || 'info') + '" aria-live="polite">' +
        '<div class="mq-panel__body">' + heading + '<p>' + esc(body) + '</p></div></aside>';
    }
    function shellTwoCol(inner, panel) {
      return el('<section class="mq-screen-grid"><div class="mq-col-main">' + inner + '</div>' + (panel ? '<div class="mq-col-side">' + panel + '</div>' : '') + '</section>');
    }
    function confirmLink(label) {
      return '<div class="mq-actions"><button type="button" class="mq-confirm" data-action="confirm" data-testid="q-confirm">' + esc(label || DATA.COPY.confirm) + ' →</button></div>';
    }
    function errorBanner() { return '<div class="mq-error" role="alert" hidden><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 3l9 16H3z" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 10v4M12 17v.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><span class="mq-error__msg"></span></div>'; }

    function showError(node, msg) { var b = node.querySelector('.mq-error'); if (b) { b.querySelector('.mq-error__msg').textContent = msg; b.hidden = false; b.classList.add('is-shown'); } }
    function clearError(node) { var b = node.querySelector('.mq-error'); if (b) { b.hidden = true; b.classList.remove('is-shown'); } }
    function revealConfirm(node, show) { var c = node.querySelector('.mq-confirm'); if (c) { c.classList.toggle('is-revealed', !!show); c.setAttribute('aria-hidden', show ? 'false' : 'true'); } if (navNextBtn) navNextBtn.disabled = !show; }

    function advance(screen, step) {
      var v = engine.validate();
      if (!v.ok) { return v; }
      track('quiz_step_complete', { screenId: step.screenId, dogIndex: step.dogIndex });
      if (hooks.onStepComplete) hooks.onStepComplete(step, engine.getState());
      var r = engine.next();
      return r;
    }
    function autoAdvance(screen, step, node) {
      var hold = reducedMotion() ? 0 : HOLD_MS;
      setTimeout(function () {
        var r = advance(screen, step);
        if (!r.ok && node) { showError(node, r.error); node.querySelectorAll('.mq-card.is-busy').forEach(function (c) { c.classList.remove('is-busy'); }); }
      }, hold);
    }
    function skip(screen, step) {
      track('quiz_step_skip', { screenId: step.screenId, dogIndex: step.dogIndex });
      engine.next();
    }

    var BUILDERS = {};

    /* ---------- _fallback ---------- */
    BUILDERS._fallback = function (screen, step, s) {
      return shellTwoCol(header(screen, step, s) + '<p class="mq-sub">…</p>' + confirmLink('Continue'));
    };

    /* ---------- welcome (Mad-Libs: dog count + names, Farmer's-Dog style) ---------- */
    BUILDERS.welcome = function (screen, step, s) {
      /* ad-campaign deep-link: ?preset=<key> swaps the headline + subcopy so the
         quiz matches the ad the customer clicked (message-match at cutover). */
      var preset = (DATA.PRESETS || {})[engine.state.preset];
      var headScreen = preset ? Object.assign({}, screen, { prompt: preset.title, sub: preset.sub }) : screen;
      var tierLine = (preset && preset.tierLine) || DATA.COPY.tierLine;
      var introBadge = (preset && preset.introBadge) || DATA.COPY.introBadge;
      var introDeliverables = (preset && preset.introDeliverables) || DATA.COPY.introDeliverables;
      var node = shellTwoCol(
        header(headScreen, step, s) +
        errorBanner() +
        '<div class="mq-madlib" data-madlib>' +
          '<p class="mq-madlib__line mq-madlib__sentence">I have <span class="mq-blank mq-blank--num"><input class="mq-inline-input mq-inline-input--num" data-field="count" type="number" inputmode="numeric" min="1" max="10" value="1" aria-label="Number of dogs" data-testid="q-dog-count"></span> <span data-dogword>dog</span><span data-named-word> named</span> <span class="mq-madlib__names" data-names></span></p>' +
        '</div>' +
        '<p class="mq-microcopy" data-namechip hidden>' + esc(DATA.COPY.nameChip) + '</p>' +
        confirmLink((preset && preset.cta) || 'Let’s go'),
        '<aside class="mq-panel" data-variant="info"><div class="mq-panel__body"><span class="mq-tier-badge mq-introonly">🎉 ' + esc(tierLine) + '</span><span class="mq-tier-badge mq-nointro-only">👋 ' + esc(DATA.COPY.tierLineReturning) + '</span><strong class="mq-panel__heading">' + esc(introBadge) + '</strong><ul class="mq-benefits">' + introDeliverables.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></div></aside>'
      );
      return node;
    };
    BUILDERS.welcome.mount = function (node, screen, step, s) {
      var NAME_EXAMPLES = ['Bella', 'Max', 'Coco', 'Luna', 'Milo', 'Daisy', 'Rocky', 'Lucy'];
      var countInput = node.querySelector('[data-field="count"]');
      var namesWrap = node.querySelector('[data-names]');
      var dogWord = node.querySelector('[data-dogword]');
      var namedWord = node.querySelector('[data-named-word]');
      var nameChip = node.querySelector('[data-namechip]');

      /* Size each name blank to its content (Farmer's Dog style) so the name is
         never clipped and short names still sit inline. A hidden mirror measures
         the REAL rendered width in the input's own bold display font — plain `ch`
         under-measures bold type and chopped names ("Rocky" → "Rocl"). */
      function sizeName(inp) {
        var mirror = sizeName._m;
        if (!mirror) {
          mirror = sizeName._m = document.createElement('span');
          mirror.setAttribute('aria-hidden', 'true');
          mirror.style.cssText = 'position:absolute;left:-9999px;top:-9999px;white-space:pre;visibility:hidden;pointer-events:none;';
          document.body.appendChild(mirror);
        }
        var cs = window.getComputedStyle(inp);
        mirror.style.fontFamily = cs.fontFamily;
        mirror.style.fontSize = cs.fontSize;
        mirror.style.fontWeight = cs.fontWeight;
        mirror.style.letterSpacing = cs.letterSpacing;
        mirror.textContent = inp.value || inp.getAttribute('placeholder') || '';
        /* The input's own padding + borders are NOT part of the mirror's text
           width — a flat +16 left ~15px of text room (16+16 padding, 2+2 border)
           and clipped "Bella" to "Be" on the highest-drop-off screen. */
        var chrome = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0)
          + (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
        inp.style.width = (Math.ceil(mirror.getBoundingClientRect().width) + chrome + 6) + 'px';
      }
      function renderNames() {
        var n = engine.state.dogCount;
        dogWord.textContent = n === 1 ? 'dog' : 'dogs';
        /* 1–2 dogs: keep the charming inline "named X & Y" (auto-sized blanks).
           3+ dogs: an inline sentence with N blanks is a cramped mess — switch
           to a clean numbered list of full-width fields (never clips a name). */
        var stacked = n > 2;
        namesWrap.className = 'mq-madlib__names' + (stacked ? ' mq-madlib__names--stacked' : '');
        if (namedWord) namedWord.style.display = stacked ? 'none' : '';
        namesWrap.innerHTML = '';
        if (stacked) {
          for (var i = 0; i < n; i++) {
            var sval = esc(engine.state.dogs[i].name || '');
            var sph = NAME_EXAMPLES[i % NAME_EXAMPLES.length];
            var row = el('<label class="mq-namerow"><span class="mq-namerow__n">' + (i + 1) + '</span>' +
              '<input class="mq-namefield" data-name-idx="' + i + '" type="text" maxlength="20" autocapitalize="words" value="' + sval + '" placeholder="' + sph + '" aria-label="Dog ' + (i + 1) + ' name" data-testid="q-dog-name-' + i + '"></label>');
            namesWrap.appendChild(row);
          }
        } else {
          for (var j = 0; j < n; j++) {
            var connector = j === 0 ? '' : (j === n - 1 ? ' & ' : ', ');
            var val = esc(engine.state.dogs[j].name || '');
            var ph = NAME_EXAMPLES[j % NAME_EXAMPLES.length];
            var line = el('<span class="mq-madlib__nameslot">' + connector +
              '<span class="mq-blank"><input class="mq-inline-input" data-name-idx="' + j + '" type="text" maxlength="20" autocapitalize="words" value="' + val + '" placeholder="' + ph + '" aria-label="Dog ' + (j + 1) + ' name" data-testid="q-dog-name-' + j + '"></span></span>');
            namesWrap.appendChild(line);
          }
          Array.prototype.forEach.call(namesWrap.querySelectorAll('.mq-inline-input'), sizeName);
        }
        refresh();
      }
      function refresh() {
        var v = engine.validate(engine.indexOfStep('welcome', null));
        revealConfirm(node, v.ok);
        nameChip.hidden = !(engine.state.dogs[0].name && engine.state.dogs[0].name.trim());
      }
      countInput.value = engine.state.dogCount;
      countInput.addEventListener('input', function () {
        var n = Math.max(1, Math.min(10, parseInt(countInput.value, 10) || 1));
        engine.setDogCount(n); renderNames();
      });
      namesWrap.addEventListener('input', function (e) {
        var inp = e.target.closest('[data-name-idx]'); if (!inp) return;
        engine.setDogName(parseInt(inp.dataset.nameIdx, 10), inp.value);
        if (inp.classList.contains('mq-inline-input')) sizeName(inp);
        if (parseInt(inp.dataset.nameIdx, 10) === 0 && !node._namedFired && inp.value) { node._namedFired = true; track('quiz_name_entered', {}); }
        refresh();
      });
      node.addEventListener('keydown', enterToConfirm(node, screen, step));
      bindConfirm(node, screen, step);
      renderNames();
      /* The width mirror can measure before DM Sans loads → blanks render too
         narrow and the placeholder clips ("Bella" → "Be") on first paint of the
         highest-drop-off screen. Re-size once fonts are actually ready. */
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(function () {
          Array.prototype.forEach.call(node.querySelectorAll('.mq-inline-input'), sizeName);
        });
      }
      if (s.isFirst) track('quiz_start', { sessionId: engine.state.sessionId });
      setTimeout(function () { var f0 = node.querySelector('[data-name-idx="0"]'); if (f0) f0.focus(); }, 60);
    };

    /* ---------- dogname (dogs added mid-flow via "+ Add another dog") ------ */
    BUILDERS.dogname = function (screen, step, s) {
      var d = engine.state.dogs[step.dogIndex] || {};
      return shellTwoCol(
        header(screen, step, s) + errorBanner() +
        '<div class="mq-field"><label class="mq-label" for="mq-dogname">Name</label>' +
          '<div class="mq-input-wrap"><input class="mq-input" id="mq-dogname" type="text" maxlength="20" autocomplete="off" autocapitalize="words" placeholder="e.g. Coco" value="' + esc(d.name || '') + '" data-testid="q-added-dog-name"><span class="mq-check" data-check></span></div></div>' +
        confirmLink('Continue')
      );
    };
    BUILDERS.dogname.mount = function (node, screen, step, s) {
      var input = node.querySelector('#mq-dogname');
      function refresh() {
        var v = engine.validate(engine.indexOfStep('dogname', step.dogIndex));
        revealConfirm(node, v.ok);
        var check = node.querySelector('[data-check]');
        if (check) check.classList.toggle('is-valid', v.ok);
      }
      input.addEventListener('input', function () { engine.setDogName(step.dogIndex, input.value.trim()); refresh(); });
      node.addEventListener('keydown', enterToConfirm(node, screen, step));
      bindConfirm(node, screen, step);
      refresh();
      setTimeout(function () { try { input.focus(); } catch (e) {} }, 60);
    };

    /* ---------- single-select cards (auto or with panel) ---------- */
    BUILDERS['single-select'] = function (screen, step, s) {
      var opts = screen.options || (screen.optionsRef ? DATA[screen.optionsRef] : []);
      var dog = step.dogIndex != null ? engine.state.dogs[step.dogIndex] : null;
      var current = currentSingleValue(screen, step);
      var cards = opts.map(function (o) {
        var label = engine.t(o.label, step.dogIndex);
        var sel = current === o.value ? ' is-selected' : '';
        return '<button type="button" class="mq-card' + sel + '" role="radio" aria-checked="' + (current === o.value) + '" data-action="select" data-value="' + esc(o.value) + '" data-testid="q-' + screen.id + '-' + esc(o.value) + '">' +
          (o.icon ? iconUse(o.icon) : '') + '<span class="mq-card__label">' + esc(label) + '</span></button>';
      }).join('');
      var layout = opts.length === 2 ? 'mq-cards--2up' : 'mq-cards--stack';
      var needsConfirm = !screen.autoAdvance;
      var inner = header(screen, step, s) + errorBanner() +
        '<div class="mq-cards ' + layout + '" role="radiogroup" aria-label="' + esc(stripTags(engine.resolveText(screen.prompt, step.dogIndex))) + '">' + cards + '</div>' +
        '<div data-panel-slot></div>' +
        (needsConfirm ? confirmLink() : '') +
        (screen.skippable ? '<button type="button" class="mq-skip" data-action="skip" data-testid="q-skip">' + esc(DATA.COPY.skip) + '</button>' : '');
      return shellTwoCol(inner, screen.panelAfterSelect ? '' : infoPanel(screen, step));
    };
    BUILDERS['single-select'].mount = function (node, screen, step, s) {
      var group = node.querySelector('.mq-cards');
      group.addEventListener('click', function (e) {
        var card = e.target.closest('.mq-card'); if (!card || card.classList.contains('is-busy')) return;
        var val = card.dataset.value;
        group.querySelectorAll('.mq-card').forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
        card.classList.add('is-pressed');
        requestAnimationFrame(function () { card.classList.remove('is-pressed'); card.classList.add('is-selected'); card.setAttribute('aria-checked', 'true'); });
        applySingle(screen, step, val);
        clearError(node);
        if (hooks.onAnswer) hooks.onAnswer(step, val);
        /* weightGoal shows a panel then Confirm; others auto-advance */
        if (screen.panelAfterSelect) { showSelectPanel(node, screen, step, val); revealConfirm(node, true); }
        else if (screen.autoAdvance) { card.classList.add('is-busy'); autoAdvance(screen, step, node); }
        else revealConfirm(node, true);
      });
      keyboardRadio(group);
      bindConfirm(node, screen, step);
      if (screen.skippable) bindSkip(node, screen, step);
      /* if revisiting with a value, show confirm AND restore the dependent panel
         since the no-rebuild model won't regenerate it */
      var _cv = currentSingleValue(screen, step);
      if (!screen.autoAdvance && _cv) {
        revealConfirm(node, true);
        if (screen.panelAfterSelect) showSelectPanel(node, screen, step, _cv);
      }
    };

    function showSelectPanel(node, screen, step, val) {
      var slot = node.querySelector('[data-panel-slot]'); if (!slot) return;
      var expert = DATA.EXPERTS.nutritionist;
      var tk = engine.tokens(step.dogIndex);
      slot.innerHTML = '<aside class="mq-panel" data-variant="expert" aria-live="polite"><div class="mq-panel__body">' +
        expertHead(expert) +
        '<strong class="mq-panel__heading">We’ve got ' + esc(tk.Name) + ' covered.</strong>' +
        '<ul class="mq-benefits"><li>Complete, balanced nutrition</li><li>Portions that adjust as ' + esc(tk.subj) + ' ages</li><li>A free measuring scoop in your first box</li></ul>' +
        '</div></aside>';
    }
    /* renderAvoidGrid removed 2026-07-03 — the "avoid preferences" screen was
       merged into sensitivities (its allergen grid now captures both). */

    function applySingle(screen, step, val) {
      var di = step.dogIndex;
      if (screen.id === 'sex') engine.setDogField(di, 'sex', val);
      else if (screen.id === 'neutered') engine.setDogField(di, 'neutered', val);
      else if (screen.id === 'currentFood') engine.setDogField(di, 'currentFood', val);
      else if (screen.id === 'weightGoal') engine.setDogField(di, 'weightGoal', val);
      else if (screen.id === 'belief') engine.setBelief(val);
    }
    function currentSingleValue(screen, step) {
      var di = step.dogIndex, d = di != null ? engine.state.dogs[di] : null;
      if (screen.id === 'sex') return d && d.sex;
      if (screen.id === 'neutered') return d && d.neutered;
      if (screen.id === 'currentFood') return d && d.currentFood;
      if (screen.id === 'weightGoal') return d && d.weightGoal;
      if (screen.id === 'belief') return engine.state.belief;
      return null;
    }

    /* belief is a Mad-Libs styled single-select — render as a sentence with chips */
    BUILDERS.belief = function (screen, step, s) {
      var tk = engine.tokens(step.dogIndex);
      var current = engine.state.belief;
      var chips = DATA.BELIEFS.map(function (o) {
        var sel = current === o.value ? ' is-selected' : '';
        return '<button type="button" class="mq-chip-opt' + sel + '" role="radio" aria-checked="' + (current === o.value) + '" data-action="select" data-value="' + esc(o.value) + '" data-testid="q-belief-' + esc(o.value) + '">' + esc(o.label) + '</button>';
      }).join('');
      var inner = header(screen, step, s) +
        '<div class="mq-belief-card">' +
          '<p class="mq-madlib__line mq-belief">I <span class="mq-belief__slot" role="radiogroup" aria-label="How you feel about fresh food">' + chips + '</span> <strong>' + esc(tk.Name) + '</strong>.</p>' +
        '</div>' +
        '<button type="button" class="mq-skip" data-action="skip" data-testid="q-skip">' + esc(DATA.COPY.skip) + '</button>';
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS.belief.mount = function (node, screen, step, s) {
      node.querySelector('.mq-belief__slot').addEventListener('click', function (e) {
        var c = e.target.closest('.mq-chip-opt'); if (!c) return;
        node.querySelectorAll('.mq-chip-opt').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        c.classList.add('is-selected'); c.setAttribute('aria-checked', 'true');
        engine.setBelief(c.dataset.value);
        if (hooks.onAnswer) hooks.onAnswer(step, c.dataset.value);
        setTimeout(function () { advance(screen, step); }, reducedMotion() ? 0 : HOLD_MS);
      });
      bindSkip(node, screen, step); /* optional — advance without priming */
    };

    /* ---------- contact (email gate, mid-funnel) ---------- */
    BUILDERS.contact = function (screen, step, s) {
      var c = engine.state.contact;
      var areas = DATA.PH_AREAS.map(function (a) { return '<option value="' + esc(a.value) + '"' + (c.area === a.value ? ' selected' : '') + '>' + esc(a.label) + '</option>'; }).join('');
      var inner = header(screen, step, s) + errorBanner() +
        '<div class="mq-field"><label class="mq-label" for="mq-email">Email</label>' +
          '<div class="mq-input-wrap"><input class="mq-input" id="mq-email" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com" value="' + esc(c.email) + '" data-field="email" data-testid="q-email"><span class="mq-check" data-check></span></div></div>' +
        '<div class="mq-field"><label class="mq-label" for="mq-area">Your area</label>' +
          '<select class="mq-input" id="mq-area" data-field="area" data-testid="q-area"><option value="">Select your area…</option>' + areas + '</select></div>' +
        '<div class="mq-serviceability" data-serviceability hidden></div>' +
        '<div class="mq-field"><label class="mq-label" for="mq-phone">Viber number <span class="mq-label__optional">(optional)</span></label>' +
          '<div class="mq-input-wrap"><input class="mq-input" id="mq-phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="09xx xxx xxxx" value="' + esc(c.phone || '') + '" data-field="phone" data-testid="q-phone"></div>' +
          '<p class="mq-help">For plan and delivery updates on Viber. No spam, ever.</p></div>' +
        '<label class="mq-checkline mq-checkline--muted"><input type="checkbox" data-field="marketingConsent"' + (c.marketingConsent ? ' checked' : '') + ' data-testid="q-marketing"> Send me occasional McDuffy tips &amp; offers — unsubscribe anytime</label>' +
        '<p class="mq-privacy">' + esc(engine.t(DATA.COPY.privacy, step.dogIndex)) + ' <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy policy</a>.</p>' +
        confirmLink(engine.state.flowMode === 'ips2026' ? 'See the plan' : 'Reveal the plan');
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS.contact.mount = function (node, screen, step, s) {
      var email = node.querySelector('[data-field="email"]');
      var area = node.querySelector('[data-field="area"]');
      var phone = node.querySelector('[data-field="phone"]');
      var check = node.querySelector('[data-check]');
      var serv = node.querySelector('[data-serviceability]');
      function refresh() {
        var valid = engine.state._helpers ? false : true; // noop guard
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value);
        check.classList.toggle('is-valid', ok);
        if (email.value.trim() && !ok) showError(node, 'Please enter a valid email address, like you@email.com.');
        else clearError(node);
        var v = engine.validate(engine.indexOfStep('contact', null));
        revealConfirm(node, v.ok);
        var a = DATA.PH_AREAS.filter(function (x) { return x.value === area.value; })[0];
        if (a) {
          serv.hidden = false;
          if (a.serviceable) { serv.className = 'mq-serviceability is-ok'; serv.innerHTML = '✓ We deliver fresh to ' + esc(a.label) + '.'; }
          else { serv.className = 'mq-serviceability is-wait'; serv.innerHTML = 'We’re not in ' + esc(a.label) + ' just yet — add your email and we’ll tell you the moment we are.'; }
        } else { serv.hidden = true; }
      }
      email.addEventListener('input', function () { engine.setContact({ email: email.value.trim() }); refresh(); });
      area.addEventListener('change', function () { engine.setContact({ area: area.value }); refresh(); track('quiz_area_select', { area: area.value }); });
      if (phone) phone.addEventListener('input', function () { var v = phone.value.trim(); engine.setContact({ phone: v, viberOptIn: !!v }); });
      node.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.addEventListener('change', function () { var p = {}; p[cb.dataset.field] = cb.checked; engine.setContact(p); });
      });
      node.addEventListener('keydown', enterToConfirm(node, screen, step));
      bindConfirm(node, screen, step, function () { track('quiz_contact_submit', {}); if (hooks.onContact) hooks.onContact(engine.getState()); });
      /* WAITLIST capture: a non-serviceable area can't advance (the delivery gate
         blocks it), so bindConfirm's success path never fires the lead capture —
         yet we promise "your email is saved". Fire it here on confirm so the
         waitlist lead IS persisted server-side. Guarded to fire once. */
      var _waitlistFired = false;
      var _confirmBtn = node.querySelector('.mq-confirm');
      if (_confirmBtn) _confirmBtn.addEventListener('click', function () {
        var a = (DATA.PH_AREAS || []).filter(function (x) { return x.value === engine.state.contact.area; })[0];
        var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(engine.state.contact.email || '');
        if (a && a.serviceable === false && okEmail && !_waitlistFired) {
          _waitlistFired = true;
          track('quiz_waitlist_join', { area: a.value });
          if (hooks.onContact) hooks.onContact(engine.getState());
        }
      });
      refresh();
    };

    /* ---------- dual-number (age) ---------- */
    BUILDERS['dual-number'] = function (screen, step, s) {
      var d = engine.state.dogs[step.dogIndex];
      var tk = engine.tokens(step.dogIndex);
      var inner = header(screen, step, s) + errorBanner() +
        '<p class="mq-madlib__line">' + esc(tk.Subj) + ' is ' +
          '<span class="mq-blank mq-blank--num"><input class="mq-inline-input mq-inline-input--num" type="number" inputmode="numeric" min="0" max="30" data-field="years" value="' + (d.ageYears != null ? d.ageYears : '') + '" aria-label="Age years" data-testid="q-age-years"></span> years ' +
          '<span class="mq-blank mq-blank--num"><input class="mq-inline-input mq-inline-input--num" type="number" inputmode="numeric" min="0" max="11" data-field="months" value="' + (d.ageMonths ? d.ageMonths : '') + '" placeholder="0" aria-label="Age months" data-testid="q-age-months"></span> months old.</p>' +
        confirmLink();
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS['dual-number'].mount = function (node, screen, step, s) {
      var years = node.querySelector('[data-field="years"]');
      var months = node.querySelector('[data-field="months"]');
      function refresh() {
        engine.setDogField(step.dogIndex, 'ageYears', years.value === '' ? null : parseInt(years.value, 10));
        engine.setDogField(step.dogIndex, 'ageMonths', months.value === '' ? 0 : parseInt(months.value, 10));
        revealConfirm(node, engine.validate().ok); clearError(node);
      }
      years.addEventListener('input', refresh); months.addEventListener('input', refresh);
      node.addEventListener('keydown', enterToConfirm(node, screen, step));
      bindConfirm(node, screen, step);
      if (engine.validate().ok) revealConfirm(node, true);
      setTimeout(function () { years.focus(); }, 60);
    };

    /* ---------- number-unit (weight) ---------- */
    BUILDERS['number-unit'] = function (screen, step, s) {
      var d = engine.state.dogs[step.dogIndex];
      var inner = header(screen, step, s) + errorBanner() +
        '<div class="mq-weight">' +
          '<div class="mq-input-wrap"><input class="mq-input mq-input--num" type="number" inputmode="decimal" min="0" step="0.1" placeholder="0.0" value="' + (d.weight != null ? d.weight : '') + '" data-field="weight" aria-label="Weight" data-testid="q-weight"><span class="mq-check" data-check></span></div>' +
          '<select class="mq-input mq-unit" data-field="unit" aria-label="Weight unit" data-testid="q-weight-unit"><option value="kg"' + (d.weightUnit === 'kg' ? ' selected' : '') + '>kg</option><option value="lbs"' + (d.weightUnit === 'lbs' ? ' selected' : '') + '>lbs</option></select>' +
        '</div>' +
        '<button type="button" class="mq-textlink" data-action="estimate" data-testid="q-weight-estimate">' + esc(DATA.COPY.estimateLink) + '</button>' +
        confirmLink();
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS['number-unit'].mount = function (node, screen, step, s) {
      var w = node.querySelector('[data-field="weight"]');
      var unit = node.querySelector('[data-field="unit"]');
      var check = node.querySelector('[data-check]');
      function refresh() {
        engine.setDogField(step.dogIndex, 'weight', w.value === '' ? null : parseFloat(w.value));
        engine.setDogField(step.dogIndex, 'weightUnit', unit.value);
        var ok = engine.validate().ok; check.classList.toggle('is-valid', ok); revealConfirm(node, ok); clearError(node);
      }
      w.addEventListener('input', function () { engine.setDogField(step.dogIndex, 'weightEstimated', false); refresh(); });
      unit.addEventListener('change', refresh);
      node.querySelector('[data-action="estimate"]').addEventListener('click', function () {
        var est = engine.estimateWeightKg(engine.state.dogs[step.dogIndex]);
        engine.setDogField(step.dogIndex, 'weightUnit', 'kg');
        engine.setDogField(step.dogIndex, 'weight', est);
        engine.setDogField(step.dogIndex, 'weightEstimated', true);
        w.value = est; unit.value = 'kg'; refresh();
        track('quiz_estimate_used', { stepId: 'weight' });
      });
      node.addEventListener('keydown', enterToConfirm(node, screen, step));
      bindConfirm(node, screen, step);
      if (engine.validate().ok) revealConfirm(node, true);
      setTimeout(function () { w.focus(); }, 60);
    };

    /* ---------- breed (expandable + typeahead) ---------- */
    BUILDERS.breed = function (screen, step, s) {
      var d = engine.state.dogs[step.dogIndex];
      var cards = screen.options.map(function (o) {
        var sel = d.breed.type === o.value ? ' is-selected' : '';
        return '<button type="button" class="mq-card mq-card--wide' + sel + '" data-action="breed-type" data-value="' + esc(o.value) + '" aria-pressed="' + (d.breed.type === o.value) + '" data-testid="q-breed-' + esc(o.value) + '"><span class="mq-card__label">' + esc(o.label) + '</span></button>';
      }).join('');
      var inner = header(screen, step, s) + errorBanner() +
        '<div class="mq-cards mq-cards--stack" data-breed-cards>' + cards + '</div>' +
        '<div data-breed-fields></div>' +
        confirmLink();
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS.breed.mount = function (node, screen, step, s) {
      var di = step.dogIndex, d = engine.state.dogs[di];
      var cardsWrap = node.querySelector('[data-breed-cards]');
      var fields = node.querySelector('[data-breed-fields]');
      function renderFields() {
        var type = d.breed.type;
        fields.innerHTML = '';
        if (type === 'pure') {
          fields.appendChild(el(typeaheadHTML('breed0', 'Select breed', d.breed.breeds[0])));
          var ta0 = fields.querySelector('.mq-typeahead');
          wireBreedTypeahead(node, ta0, di, 0); ta0._onpick = refresh;
        } else if (type === 'mixed') {
          fields.appendChild(el(typeaheadHTML('breed0', 'Main breed', d.breed.breeds[0])));
          fields.appendChild(el(typeaheadHTML('breed1', 'Second breed', d.breed.breeds[1])));
          if (d.breed.breeds.length >= 2 || d.breed._showThird) fields.appendChild(el(typeaheadHTML('breed2', 'Third breed', d.breed.breeds[2])));
          else fields.appendChild(el('<button type="button" class="mq-textlink" data-action="add-breed">Add a third breed</button>'));
          [].forEach.call(fields.querySelectorAll('.mq-typeahead'), function (ta, i) { wireBreedTypeahead(node, ta, di, i); ta._onpick = refresh; });
          var addBtn = fields.querySelector('[data-action="add-breed"]');
          if (addBtn) addBtn.addEventListener('click', function () { d.breed._showThird = true; renderFields(); });
        } else if (type === 'unknown') {
          fields.appendChild(el('<div class="mq-size-pick" role="radiogroup" aria-label="Dog size">' +
            ['small', 'medium', 'large', 'giant'].map(function (sz) {
              var sel = d.breed.sizeFallback === sz ? ' is-selected' : '';
              return '<button type="button" class="mq-card mq-card--size' + sel + '" role="radio" aria-checked="' + (d.breed.sizeFallback === sz) + '" data-action="size" data-value="' + sz + '" data-testid="q-size-' + sz + '">' + sz.charAt(0).toUpperCase() + sz.slice(1) + '</button>';
            }).join('') + '</div>'));
          fields.querySelector('.mq-size-pick').addEventListener('click', function (e) {
            var b = e.target.closest('[data-action="size"]'); if (!b) return;
            engine.setBreed(di, { sizeFallback: b.dataset.value });
            fields.querySelectorAll('.mq-card--size').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
            b.classList.add('is-selected'); b.setAttribute('aria-checked', 'true');
            refresh();
          });
        }
        refresh();
      }
      function refresh() { var ok = engine.validate().ok; revealConfirm(node, ok); if (ok) clearError(node); }
      cardsWrap.addEventListener('click', function (e) {
        var c = e.target.closest('[data-action="breed-type"]'); if (!c) return;
        cardsWrap.querySelectorAll('.mq-card').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); });
        c.classList.add('is-selected'); c.setAttribute('aria-pressed', 'true');
        engine.setBreed(di, { type: c.dataset.value, breeds: c.dataset.value === d.breed.type ? d.breed.breeds : [] });
        /* move selected to top visually */ cardsWrap.insertBefore(c, cardsWrap.firstChild);
        renderFields();
      });
      bindConfirm(node, screen, step);
      if (d.breed.type) renderFields();
    };

    /* ---------- multi-select (sensitivities, goals, flavors) ---------- */
    BUILDERS['multi-select'] = function (screen, step, s) {
      var opts = screen.optionsRef ? DATA[screen.optionsRef] : (screen.options || []);
      var di = step.dogIndex, d = engine.state.dogs[di];
      var key = multiKey(screen.id);
      var sel = d[key] || [];
      /* flavors: don't offer a protein the owner just EXCLUDED as an allergen —
         "loves Fish" beside a declared fish sensitivity reads as us not listening
         (the recommender already filters it; this hides the contradiction upstream) */
      if (screen.id === 'flavors') {
        var excluded = (d.excludedAllergens || []).concat(d.avoidPreferences || []);
        if (excluded.length) opts = opts.filter(function (o) { return o.exclusive || excluded.indexOf(o.value) < 0; });
      }
      var cards = opts.map(function (o) {
        var on = sel.indexOf(o.value) >= 0;
        var label = engine.t(o.label, di);
        return '<button type="button" class="mq-card mq-card--multi' + (on ? ' is-selected' : '') + '" role="checkbox" aria-checked="' + on + '" data-action="multi" data-value="' + esc(o.value) + '"' + (o.exclusive ? ' data-exclusive="1"' : '') + ' data-testid="q-' + screen.id + '-' + esc(o.value) + '">' +
          (o.icon ? iconUse(o.icon) : '') + '<span class="mq-card__label">' + esc(label) + '</span></button>';
      }).join('');
      var inner = header(screen, step, s) + errorBanner() +
        '<div class="mq-cards mq-cards--grid" role="group" aria-label="' + esc(stripTags(engine.resolveText(screen.prompt, di))) + '">' + cards + '</div>' +
        '<div data-reveal-slot></div>' +
        '<div data-panel-slot></div>' +
        confirmLink() +
        (screen.skippable ? '<button type="button" class="mq-skip" data-action="skip" data-testid="q-skip">' + esc(DATA.COPY.skip) + '</button>' : '');
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS['multi-select'].mount = function (node, screen, step, s) {
      var di = step.dogIndex, d = engine.state.dogs[di], key = multiKey(screen.id);
      var exclusiveVals = (screen.optionsRef ? DATA[screen.optionsRef] : screen.options || []).filter(function (o) { return o.exclusive; }).map(function (o) { return o.value; });
      var revealSlot = node.querySelector('[data-reveal-slot]');
      var panelSlot = node.querySelector('[data-panel-slot]');
      node.querySelector('.mq-cards').addEventListener('click', function (e) {
        var c = e.target.closest('[data-action="multi"]'); if (!c) return;
        engine.toggleInArray(di, key, c.dataset.value, exclusiveVals);
        /* reflect selection */
        var sel = engine.state.dogs[di][key] || [];
        node.querySelectorAll('[data-action="multi"]').forEach(function (b) {
          var on = sel.indexOf(b.dataset.value) >= 0; b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on);
        });
        onMultiChange();
        if (hooks.onAnswer) hooks.onAnswer(step, sel);
      });
      function onMultiChange() {
        var sel = engine.state.dogs[di][key] || [];
        revealConfirm(node, true); /* multi-select: confirm always available (incl. empty = "none") */
        /* sensitivities → allergen grid when food-sensitivities chosen */
        if (screen.id === 'sensitivities') {
          if (sel.indexOf('food-sensitivities') >= 0) {
            if (!revealSlot.querySelector('.mq-allergens')) { revealSlot.innerHTML = allergenGridHTML('excludedAllergens', step, 'Which ingredients should we leave out?'); wireAllergenGrid(node, revealSlot, step, 'excludedAllergens'); }
          } else { revealSlot.innerHTML = ''; }
        }
        /* goals → expert panel for the last-picked goal */
        if (screen.id === 'goals') {
          var last = sel[sel.length - 1];
          var go = DATA.HEALTH_GOALS.filter(function (x) { return x.value === last; })[0];
          if (go) panelSlot.innerHTML = goalExpertPanel(go, step); else panelSlot.innerHTML = '';
        }
      }
      bindConfirm(node, screen, step);
      if (screen.skippable) bindSkip(node, screen, step);
      onMultiChange();
    };

    function multiKey(id) { return id === 'sensitivities' ? 'sensitivities' : (id === 'goals' ? 'healthGoals' : (id === 'flavors' ? 'flavors' : id)); }

    function allergenGridHTML(key, step, prompt) {
      var di = step.dogIndex, sel = engine.state.dogs[di][key] || [];
      var pills = DATA.ALLERGENS.map(function (a) {
        var on = sel.indexOf(a.value) >= 0;
        return '<button type="button" class="mq-pill" role="checkbox" aria-checked="' + on + '" aria-label="' + (on ? 'Excluded: ' : 'Exclude ') + esc(a.label) + '" data-action="pill" data-value="' + esc(a.value) + '" data-testid="q-allergen-' + esc(a.value) + '">' + esc(a.label) + '</button>';
      }).join('');
      return '<div class="mq-allergens"><p class="mq-subprompt">' + esc(prompt) + '</p><div class="mq-pillgrid" role="group">' + pills + '</div><div data-allergen-panel></div></div>';
    }
    function wireAllergenGrid(node, scope, step, key) {
      var di = step.dogIndex;
      var panel = scope.querySelector('[data-allergen-panel]');
      scope.querySelector('.mq-pillgrid').addEventListener('click', function (e) {
        var p = e.target.closest('[data-action="pill"]'); if (!p) return;
        engine.toggleInArray(di, key, p.dataset.value);
        var sel = engine.state.dogs[di][key] || [];
        var on = sel.indexOf(p.dataset.value) >= 0;
        p.setAttribute('aria-checked', on); p.setAttribute('aria-label', (on ? 'Excluded: ' : 'Exclude ') + p.textContent);
        if (key === 'excludedAllergens') track('quiz_allergen_excluded', { allergen: p.dataset.value });
        if (sel.length) {
          panel.innerHTML = '<aside class="mq-panel" data-variant="confirm" aria-live="polite"><div class="mq-panel__body"><strong class="mq-panel__heading">We’ll leave that out.</strong><p>' + esc(DATA.COPY.crossContam) + '</p></div></aside>';
        } else panel.innerHTML = '';
      });
    }
    function goalExpertPanel(go, step) {
      var tk = engine.tokens(step.dogIndex);
      var expert = DATA.EXPERTS[go.expert] || DATA.EXPERTS.vet;
      var bullets = go.bullets.map(function (b) { return '<li>' + esc(b.replace('{object}', tk.obj).replace('{subject}', tk.subj)) + '</li>'; }).join('');
      return '<aside class="mq-panel" data-variant="expert" aria-live="polite"><div class="mq-panel__body">' + expertHead(expert) +
        '<strong class="mq-panel__heading">' + esc(go.heading) + '</strong><ul class="mq-benefits">' + bullets + '</ul></div></aside>';
    }
    /* Honest authority marker (2026-07-03). A fake face + placeholder initials
       CONFIRM the "legit, or just a nice website?" doubt, so instead of a person
       we state a claim McDuffy can actually back: the recipes are complete &
       balanced, formulated to AAFCO standards (straight off the recipe tech
       sheets). No vet/person is implied — owner confirmed there is no vet to
       name. (If a real, named expert is ever added — verified:true + headshot +
       name in DATA.EXPERTS — the panel auto-upgrades to the photo + name.) */
    function expertHead(expert) {
      if (expert && expert.verified && expert.headshot) {
        return '<div class="mq-expert">' +
          '<img class="mq-panel__headshot" src="' + esc(expert.headshot) + '" alt="' + esc(expert.name + ', ' + expert.title) + '">' +
          '<div class="mq-expert__id"><strong>' + esc(expert.name) + '</strong><span>' + esc(expert.title) + '</span></div></div>';
      }
      return '<div class="mq-expert mq-expert--factual">' +
        '<svg class="mq-expert__seal" viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M12 2l2.4 1.7 2.9-.3 1.2 2.7 2.5 1.5-.6 2.9.6 2.9-2.5 1.5-1.2 2.7-2.9-.3L12 22l-2.4-1.7-2.9.3-1.2-2.7-2.5-1.5.6-2.9-.6-2.9 2.5-1.5 1.2-2.7 2.9.3z" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M8.5 12l2.4 2.4 4.6-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<div class="mq-expert__id"><strong>Complete &amp; balanced nutrition</strong><span>Formulated to AAFCO standards</span></div></div>';
    }

    /* ---------- slider (activity) ---------- */
    BUILDERS.slider = function (screen, step, s) {
      var d = engine.state.dogs[step.dogIndex];
      var tiers = DATA.ACTIVITY_TIERS;
      var idx = tiers.map(function (t) { return t.value; }).indexOf(d.activityTier);
      if (idx < 0) idx = 1; /* default to Steady (moderate) */
      var inner = header(screen, step, s) + errorBanner() +
        '<div class="mq-slider">' +
          '<input type="range" min="0" max="' + (tiers.length - 1) + '" step="1" value="' + idx + '" class="mq-range" data-field="activity" aria-label="Activity level" data-testid="q-activity">' +
          '<div class="mq-slider__ticks">' + tiers.map(function (t) { return '<span>' + esc(t.label) + '</span>'; }).join('') + '</div>' +
        '</div>' +
        '<div class="mq-tier-card" data-tier></div>' +
        '<label class="mq-checkline"><input type="checkbox" data-field="working"' + (d.workingDog ? ' checked' : '') + ' data-testid="q-working"> ' + esc(engine.tokens(step.dogIndex).Subj) + ' is a working dog</label>' +
        confirmLink();
      return shellTwoCol(inner, infoPanel(screen, step));
    };
    BUILDERS.slider.mount = function (node, screen, step, s) {
      var di = step.dogIndex, tiers = DATA.ACTIVITY_TIERS;
      var range = node.querySelector('[data-field="activity"]');
      var tierCard = node.querySelector('[data-tier]');
      function paint() {
        var i = parseInt(range.value, 10); var t = tiers[i];
        engine.setDogField(di, 'activityTier', t.value);
        range.setAttribute('aria-valuetext', t.label + ' — ' + t.detail);
        tierCard.innerHTML = '<div class="mq-tier-card__icon" aria-hidden="true">' + iconUse(t.icon) + '</div><div><strong>' + esc(t.label) + '</strong><span>' + esc(t.detail) + '</span></div>';
        var pctFill = (i / (tiers.length - 1)) * 100;
        range.style.setProperty('--mq-range-fill', pctFill + '%');
        revealConfirm(node, true);
        track('quiz_slider_changed', { tier: t.value });
      }
      range.addEventListener('input', paint);
      node.querySelector('[data-field="working"]').addEventListener('change', function (e) {
        engine.setDogField(di, 'workingDog', e.target.checked);
        if (e.target.checked) { range.value = tiers.length - 1; paint(); var t = tiers[tiers.length - 1]; announce('Set to ' + t.label + ' — ' + t.detail); }
      });
      bindConfirm(node, screen, step);
      paint();
    };

    /* ---------- brand (typeahead, skippable) ---------- */
    /* BUILDERS.brand removed 2026-07-03 with the currentBrand screen (kind:'brand'
       no longer exists in the flow). */

    /* ---------- summary ---------- */
    BUILDERS.summary = function (screen, step, s) {
      var multi = engine.state.dogCount > 1;
      var groups = ['basics', 'health', 'lifestyle', 'meals'];
      var labels = { basics: 'Basics', health: 'Health', lifestyle: 'Lifestyle', meals: 'Meals' };
      var dogsHtml = engine.state.dogs.map(function (d, di) {
        var sum = engine.summaryFor(di);
        var rows = groups.map(function (g) {
          var items = sum[g] || [];
          var firstScreen = { basics: 'sex', health: 'sensitivities', lifestyle: 'activity', meals: 'currentFood' }[g];
          return '<div class="mq-recap__row"><span class="mq-recap__label">' + esc(labels[g]) + '</span>' +
            '<span class="mq-recap__val">' + (items.length ? esc(items.join(' · ')) : '<em>—</em>') + '</span>' +
            '<button type="button" class="mq-recap__edit" data-action="edit" data-screen="' + firstScreen + '" data-dog="' + di + '" aria-label="Edit ' + esc(labels[g]) + ' for ' + esc(d.name || 'dog') + '">Edit</button></div>';
        }).join('');
        return '<div class="mq-recap"><h2 class="mq-recap__name">' + esc(engine.tokens(di).Name) + '</h2>' + rows + '</div>';
      }).join('');
      var inner = header(screen, step, s) +
        '<div class="mq-recap-list">' + dogsHtml + '</div>' +
        '<div class="mq-actions"><button type="button" class="mq-cta" data-action="to-reveal" data-testid="q-see-plan">' + (multi ? 'See the plan' : 'See ' + esc(engine.tokens(0).NamePoss) + ' plan') + ' →</button></div>';
      return shellTwoCol(inner);
    };
    BUILDERS.summary.mount = function (node, screen, step, s) {
      node.addEventListener('click', function (e) {
        var ed = e.target.closest('[data-action="edit"]');
        if (ed) { track('quiz_summary_edit_clicked', { screenId: ed.dataset.screen }); engine.gotoScreen(ed.dataset.screen, parseInt(ed.dataset.dog, 10)); return; }
        var go = e.target.closest('[data-action="to-reveal"]');
        if (go) { track('quiz_summary_view', {}); engine.next(); }
      });
    };

    /* ---------- reveal (server-computed grams/bags/₱) ---------- */
    BUILDERS.reveal = function (screen, step, s) {
      var inner = header(screen, step, s) +
        '<div class="mq-reveal" data-reveal aria-live="polite">' +
          '<div class="mq-reveal__loading mq-reveal__cooking">' + dogPoseSVG('you', 'mq-cook-dog') + '<span>Working out ' + esc(engine.tokens(0).NamePoss) + ' portions…</span></div>' +
        '</div>' +
        '<div class="mq-actions"><button type="button" class="mq-cta" data-action="to-plan" data-testid="q-unlock-plan" hidden>Build the full plan →</button></div>';
      return shellTwoCol(inner);
    };
    BUILDERS.reveal.mount = function (node, screen, step, s) {
      var box = node.querySelector('[data-reveal]');
      var cta = node.querySelector('[data-action="to-plan"]');
      cta.addEventListener('click', function () { engine.next(); });
      if (!hooks.onReveal) { box.innerHTML = '<p class="mq-sub">Ready.</p>'; cta.hidden = false; revealConfirm(node, true); return; }
      /* one-shot settle guard: the reveal fetch (boot.api) has no network timeout,
         so a stalled mobile connection would leave the cooking-dog spinning forever
         and the customer stranded on "Working out … portions" (Next stays disabled).
         Whichever of {result, error, REVEAL_MAX_MS timeout} lands first wins. */
      var settled = false;
      function unlock() { cta.hidden = false; revealConfirm(node, true); try { cta.focus({ preventScroll: true }); } catch (e) {} }
      function showBundle(bundle) {
        renderRevealBundle(box, bundle);
        /* announce the computed plan to AT, then move focus to the CTA */
        var pd0 = bundle && bundle.perDog && bundle.perDog[0];
        if (pd0) announce(pd0.name + '’s portion is ready: about ' + pd0.gramsPerDay + ' grams a day, ' + pd0.bagsPerMonth + (pd0.bagsPerMonth === 1 ? ' bag' : ' bags') + ' a month.');
        track('quiz_reveal_view', { totalBags: bundle && bundle.totalBags });
      }
      function fallback() { box.innerHTML = '<p class="mq-sub">We’ll finish the numbers on the next step.</p>'; }
      var minWait = new Promise(function (r) { setTimeout(r, 1200); }); /* keep the cooking-dog on screen long enough to feel like real work */
      Promise.all([hooks.onReveal(engine.getState()), minWait]).then(function (arr) {
        /* a reveal that lands AFTER the timeout still upgrades the numbers in place
           (harmless if the box has since been detached by navigating on) */
        if (settled) { if (arr[0]) renderRevealBundle(box, arr[0]); return; }
        settled = true; showBundle(arr[0]); unlock();
      }).catch(function () {
        if (settled) return; settled = true; fallback(); unlock();
      });
      setTimeout(function () {
        if (settled) return; settled = true; fallback(); unlock();
      }, REVEAL_MAX_MS);
    };
    /* PORTIONS + PRICE only — no pouches, no recipe names, no ingredients.
       The plan screen (next) is the single place the box is shown; the reveal
       must never preview recipes the plan then swaps (owner, 2026-07-03:
       "don't repeat"). Pouches make their one big entrance on the plan fan. */
    function renderRevealBundle(box, b) {
      if (!b) { box.innerHTML = '<p class="mq-sub">Ready.</p>'; return; }
      var dogs = b.perDog || [];
      var multi = dogs.length > 1;
      var perDog = dogs.map(function (pd, i) {
        /* the ENGINE is the source of truth for the dog's name — never the reveal
           payload (a stale/stubbed server name must not show here) */
        var dogName = ((engine.state.dogs[i] || {}).name || pd.name || 'Your dog');
        /* bug-hunt B2: show the DEFAULT-MIX bag count the plan screen will render,
           not the single-recipe teaser (they disagreed after B1). Falls back to the
           server per-dog value when the plan-mix count isn't available. */
        var planBags = (b.planBags && b.planBags[i] > 0) ? b.planBags[i] : pd.bagsPerMonth;
        return '<div class="mq-reveal__dog">' +
          '<strong>' + esc(engine.tokens(i).Name || dogName) + '</strong>' +
          '<div class="mq-reveal__big">' + esc(pd.gramsPerDay) + '<span>g of fresh food / day</span></div>' +
          '<p class="mq-reveal__sub">≈ ' + esc(planBags) + (planBags === 1 ? ' bag' : ' bags') + ' a month</p></div>';
      }).join('');
      /* returning subscribers (introEligible === false) get honest ongoing
         pricing — the 40%-off framing must never outrun the actual charge */
      var noIntro = b.introEligible === false;
      /* B2: prefer the plan's default-mix per-day price so "From ₱X/day" matches
         the very next screen; fall back to the server single-recipe teaser. */
      var perDayPhp = noIntro
        ? (b.planPricePerDayOngoingPhp != null ? b.planPricePerDayOngoingPhp : b.pricePerDayOngoingPhp)
        : (b.planPricePerDayFromPhp != null ? b.planPricePerDayFromPhp : b.pricePerDayFromPhp);
      var priceLine = perDayPhp != null ? '<p class="mq-reveal__price">From <strong>' + peso(perDayPhp) + '/day</strong> on a subscription</p>' : '';
      /* the 20% month-2 line renders ONLY from a server-carried cycleSchedule
         (ramp live 2026-07-06) — never hardcoded; env-off/ineligible degrade */
      var revealPct2 = (b.cycleSchedule && b.cycleSchedule.length >= 3) ? (Number(b.cycleSchedule[1] && b.cycleSchedule[1].discountPercent) || 0) : 0;
      var tierLine = noIntro
        ? '<p class="mq-reveal__tier">Welcome back — member pricing on every box.</p>'
        : '<p class="mq-reveal__tier">🎉 ' + esc(DATA.COPY.tierLine) + (revealPct2 > 0 ? ' · ' + revealPct2 + '% off your second' : '') + '</p>';
      /* free-tag intentionally NOT repeated here — it's sold once on the plan card
         and itemized on the review receipt (2026-07-03 repetition trim). */
      box.innerHTML = '<div class="mq-reveal__dogs' + (multi ? ' mq-reveal__dogs--multi' : '') + '">' + perDog + '</div>' + priceLine + tierLine +
        '<p class="mq-reveal__note">Based on age, breed, weight & activity. Next up: the recipes we picked. ' + esc(DATA.COPY.riskReversal) + '</p>';
    }

    /* ---------- plan + review (handled by boot via hooks.onPlan/onReview) -- */
    BUILDERS.plan = function (screen, step, s) {
      var inner = header(screen, step, s) + '<div class="mq-plan" data-plan></div>';
      return shellTwoCol(inner);
    };
    BUILDERS.plan.mount = function (node, screen, step, s) { if (hooks.onPlan) hooks.onPlan(node.querySelector('[data-plan]'), engine.getState()); };
    BUILDERS.review = function (screen, step, s) {
      var inner = header(screen, step, s) + '<div class="mq-review" data-review></div>';
      return shellTwoCol(inner);
    };
    BUILDERS.review.mount = function (node, screen, step, s) { if (hooks.onReview) hooks.onReview(node.querySelector('[data-review]'), engine.getState()); };

    /* ---------- shared wiring helpers ---------- */
    function bindConfirm(node, screen, step, extra) {
      var c = node.querySelector('.mq-confirm');
      if (!c) return;
      c.addEventListener('click', function () {
        var r = advance(screen, step);
        if (!r.ok) showError(node, r.error);
        else if (extra) extra();
      });
    }
    function bindSkip(node, screen, step) {
      var sk = node.querySelector('.mq-skip'); if (!sk) return;
      sk.addEventListener('click', function () { skip(screen, step); });
    }
    function enterToConfirm(node, screen, step) {
      return function (e) {
        if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox') {
          e.preventDefault();
          var r = advance(screen, step);
          if (!r.ok) showError(node, r.error);
        }
      };
    }
    function keyboardRadio(group) {
      /* WAI-ARIA radiogroup roving tabindex: exactly one card is a tab stop
         (the selected one, else the first). Arrows move focus + the tab stop;
         Enter/Space activates (which selects, and may auto-advance). */
      function roving() {
        var cards = [].slice.call(group.querySelectorAll('.mq-card'));
        var sel = group.querySelector('.mq-card.is-selected') || cards[0];
        cards.forEach(function (c) { c.tabIndex = (c === sel) ? 0 : -1; });
      }
      roving();
      group.addEventListener('click', roving);
      group.addEventListener('keydown', function (e) {
        var cards = [].slice.call(group.querySelectorAll('.mq-card'));
        var i = cards.indexOf(document.activeElement);
        var target = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); target = cards[(i + 1 + cards.length) % cards.length]; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); target = cards[(i - 1 + cards.length) % cards.length]; }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (document.activeElement.classList.contains('mq-card')) document.activeElement.click(); return; }
        if (target) { cards.forEach(function (c) { c.tabIndex = -1; }); target.tabIndex = 0; target.focus(); }
      });
    }

    /* now that all BUILDERS are defined, subscribe + do the first render */
    engine.subscribe(function () { render(); });
    render({ instant: true });

    return { render: render, engine: engine };
  }

  /* ---------- typeahead (combobox) ---------- */
  function typeaheadHTML(id, label, current, dataset) {
    var val = current ? esc(current.label) : '';
    var ph = 'e.g. Shih Tzu';
    return '<div class="mq-field mq-typeahead" data-dataset="' + (dataset || 'BREEDS') + '">' +
      '<label class="mq-label" for="mq-ta-' + id + '">' + esc(label) + '</label>' +
      '<div class="mq-input-wrap"><input class="mq-input" id="mq-ta-' + id + '" type="text" autocomplete="off" placeholder="' + ph + '" value="' + val + '" data-testid="q-ta-' + id + '"><span class="mq-check" data-check></span></div>' +
      '<ul class="mq-typeahead__list" id="mq-lb-' + id + '" role="listbox"></ul></div>';
  }
  function cap(s) { s = String(s || ''); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  /* the typeahead wiring lives on the view closure scope through these globals */
  window.MQ_View = { mountView: mountView, _esc: esc };

  /* Breed/brand typeahead wiring needs engine; attach as closures used above. */
  function wireBreedTypeahead(node, root, di, slot) { _wireTypeahead(node, root, function (q) { return searchBreeds(q); }, function (item) { _engine.setBreed(di, breedPatch(di, slot, item)); }, true); }
  function breedPatch(di, slot, item) {
    var d = _engine.state.dogs[di]; var breeds = (d.breed.breeds || []).slice();
    breeds[slot] = { id: item.id, label: item.label, size: item.size }; /* keep slot positions; readers filter holes */
    return { breeds: breeds };
  }
  function searchBreeds(q) {
    q = q.toLowerCase();
    return (window.MQ_DATA.BREEDS).filter(function (b) { return b.label.toLowerCase().indexOf(q) >= 0; }).slice(0, 8)
      .map(function (b) { return { id: b.id, label: b.label, size: b.size }; });
  }
  var _engine = null;
  function _wireTypeahead(node, rootEl, fetchFn, onSelect, sizeAnnotated) {
    var input = rootEl.querySelector('input'), list = rootEl.querySelector('.mq-typeahead__list'), check = rootEl.querySelector('[data-check]');
    var rows = [], active = -1, debounce, picked = false;
    /* unique per-instance id prefix so multiple typeaheads (cross-breed) don't
       collide on option ids / aria-activedescendant */
    var uid = (input.id || 'ta').replace('mq-ta-', '');
    if (list.id) input.setAttribute('aria-controls', list.id);
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
    function render(items) {
      rows = items; active = -1;
      list.innerHTML = items.map(function (it, i) { return '<li id="mq-opt-' + uid + '-' + i + '" role="option" class="mq-typeahead__opt" aria-selected="false" data-i="' + i + '">' + esc(it.label) + '</li>'; }).join('');
      var open = items.length > 0; rootEl.classList.toggle('is-open', open); input.setAttribute('aria-expanded', String(open));
    }
    function choose(i) { var it = rows[i]; if (!it) return; input.value = it.label; rootEl.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); check.classList.add('is-valid'); picked = true; onSelect(it); if (rootEl._onpick) rootEl._onpick(); }
    /* accept whatever the user typed even if it isn't in the list — never let them get stuck */
    function acceptTyped() {
      if (picked) return;
      var label = input.value.trim().replace(/\s*\(.*\)\s*$/, '').trim();
      if (label.length < 2) return;
      check.classList.add('is-valid'); picked = true;
      onSelect({ id: label.toLowerCase().replace(/[^a-z0-9]+/g, '-'), label: label, size: sizeAnnotated ? 'medium' : '' });
      if (rootEl._onpick) rootEl._onpick();
    }
    input.addEventListener('blur', function () { setTimeout(function () { if (!rootEl.classList.contains('is-open')) acceptTyped(); }, 150); });
    input.addEventListener('input', function () {
      picked = false;
      check.classList.remove('is-valid');
      clearTimeout(debounce); debounce = setTimeout(function () { var q = input.value.trim(); if (q.length < 2) { render([]); return; } render(fetchFn(q)); }, 140);
    });
    input.addEventListener('keydown', function (e) {
      if (!rootEl.classList.contains('is-open')) { if (e.key === 'Enter') { e.preventDefault(); acceptTyped(); } return; }
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(active + 1, rows.length - 1); hl(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(active - 1, 0); hl(); }
      else if (e.key === 'Enter') { e.preventDefault(); choose(active < 0 ? 0 : active); }
      else if (e.key === 'Escape') { rootEl.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); }
    });
    function hl() { [].forEach.call(list.children, function (o, i) { o.setAttribute('aria-selected', i === active); if (i === active) input.setAttribute('aria-activedescendant', o.id); }); }
    list.addEventListener('click', function (e) { var li = e.target.closest('.mq-typeahead__opt'); if (li) choose(parseInt(li.dataset.i, 10)); });
    /* outside-click close is handled by ONE delegated listener in mountView (avoids a per-instance leak) */
  }
  /* expose a setter so boot can hand the engine to the typeahead helpers */
  window.MQ_View.useEngine = function (engine) { _engine = engine; };

  /* original McDuffy sitting dog (line-art, NOT a tails asset). Head + tail are
     grouped so they animate independently (low-key sway / wag / blink). */
  function dogPoseSVG(chapter, cls, name) {
    cls = cls || 'mq-shell-dog';
    var nm = String(name || '').replace(/[^\w\- ]/g, '').slice(0, 12);
    var body =
      '<path d="M104 122C80 130 64 152 60 186 56 218 66 254 92 258 116 262 128 262 152 258 178 254 186 218 182 186 178 152 160 130 136 122"/>' +
      '<path d="M102 200C100 220 100 236 102 256"/>' +
      '<path d="M138 200C140 220 140 236 138 256"/>' +
      '<path d="M90 256c0-6 6-10 12-10s12 4 12 10"/>' +
      '<path d="M126 256c0-6 6-10 12-10s12 4 12 10"/>';
    var tail = '<g class="mq-dog-tail"><path d="M170 206C196 202 210 180 202 156"/></g>';
    var head =
      '<g class="mq-dog-head">' +
        '<path d="M82 82C82 57 99 42 120 42 141 42 158 57 158 82 158 101 146 115 128 119L112 119C94 115 82 101 82 82Z"/>' +
        '<path d="M90 50C74 50 63 68 67 92 69 108 79 118 91 118"/>' +
        '<path d="M150 50C166 50 177 68 173 92 171 108 161 118 149 118"/>' +
        '<ellipse cx="120" cy="110" rx="7" ry="5" fill="currentColor" stroke="none"/>' +
        '<path d="M120 116C120 123 113 126 108 121"/>' +
        '<path d="M120 116C120 123 127 126 132 121"/>' +
        '<path d="M116 122c0 6 8 6 8 0"/>' +
        '<circle class="mq-dog-eye" cx="105" cy="80" r="4.8" fill="currentColor" stroke="none"/>' +
        '<circle class="mq-dog-eye" cx="135" cy="80" r="4.8" fill="currentColor" stroke="none"/>' +
      '</g>';
    var sz = nm.length > 7 ? 13 : (nm.length > 5 ? 15 : 18);
    var bowl = nm ? (
      '<g class="mq-dog-bowl">' +
      '<g class="mq-dog-excite" stroke-width="5">' +
        '<path d="M-98 196l-9-4"/>' +
        '<path d="M-105 207h-9"/>' +
        '<path d="M-100 218l-9 4"/>' +
      '</g>' +
      '<path d="M-96 226C-96 250 -80 266 -56 266 -32 266 -16 250 -16 226"/>' +
      '<ellipse cx="-56" cy="224" rx="42" ry="10"/>' +
      '<g stroke-width="4">' +
        '<circle cx="-76" cy="219" r="5.5"/>' +
        '<circle cx="-62" cy="214" r="6"/>' +
        '<circle cx="-48" cy="216" r="5.5"/>' +
        '<circle cx="-35" cy="214" r="6"/>' +
        '<circle cx="-55" cy="222" r="5"/>' +
        '<circle cx="-42" cy="223" r="5"/>' +
      '</g>' +
      '<text x="-56" y="251" text-anchor="middle" font-family="Fredoka, sans-serif" font-size="' + sz + '" font-weight="700" fill="currentColor" stroke="none"' + (nm.length * sz * 0.6 > 64 ? ' textLength="64" lengthAdjust="spacingAndGlyphs"' : '') + '>' + nm + '</text>' +
      '</g>'
    ) : '';
    var vb = nm ? '-120 30 345 248' : '0 0 240 280';
    return '<svg class="' + cls + '" viewBox="' + vb + '" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + bowl + body + tail + head + '</svg>';
  }

  function dogMascotSVG() {
    /* original McDuffy trotting-dog, side profile facing the finish (NOT a tails asset).
       Leg pairs + tail are grouped so CSS can swing them into a run as it rides the bar. */
    return '<svg viewBox="0 0 88 54" width="46" height="28" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<g class="mq-run-tail"><path d="M17 27C9 25 6 17 9 9"/></g>' +
      '<g class="mq-run-back">' +
        '<path d="M27 34l-3 15"/>' +
        '<path d="M35 34l1 15"/>' +
      '</g>' +
      '<g class="mq-run-front">' +
        '<path d="M52 34l-1 15"/>' +
        '<path d="M60 34l3 15"/>' +
      '</g>' +
      /* body (bean) */
      '<path d="M17 28C14 18 24 14 38 14 52 14 60 16 62 23 63 28 59 35 49 36 35 37 24 36 17 28Z"/>' +
      /* round head + short snout to the right */
      '<path d="M61 24C60 14 69 10 76 12 82 14 85 19 87 23 88 26 86 30 82 30 71 31 62 31 61 24Z"/>' +
      /* floppy ear — a slim teardrop hanging down the back of the head (the "dog" cue) */
      '<path d="M66 13C62 13 60 18 61 23 62 28 65 29 66 25 67 21 68 15 66 13Z" fill="currentColor" stroke="none"/>' +
      /* eye (clearly on the head, forward of the ear) + nose at the snout tip */
      '<circle cx="77" cy="21" r="1.8" fill="currentColor" stroke="none"/>' +
      '<circle cx="86.5" cy="24.5" r="1.9" fill="currentColor" stroke="none"/>' +
    '</svg>';
  }
  function iconUse(name) { return '<svg class="mq-icon" aria-hidden="true" width="28" height="28"><use href="#mqi-' + name + '"></use></svg>'; }

})(typeof window !== 'undefined' ? window : this);
